import React, { FunctionComponent } from 'react'
import { Layer } from 'react-map-gl'

import { useCadastreMapTheme } from './hooks/useCadastreMapTheme'

export interface CadastreMapParcelLayersProps {
  clustering: boolean
  enabled: boolean

  pointsSource: string
  clusterSource: string

  filteredSource: string
  unfilteredSource: string
}

export const CadastreMapParcelLayers: FunctionComponent<CadastreMapParcelLayersProps> =
  ({
    clustering,
    enabled,
    pointsSource,
    clusterSource,
    filteredSource: fillSource,
    unfilteredSource: linesSource,
  }) => {
    const [theme] = useCadastreMapTheme()

    return (
      <>
        <Layer
          id="parcel-cluster-circle"
          source={clusterSource}
          type="circle"
          filter={['has', 'point_count']}
          layout={{
            visibility: clustering && enabled ? 'visible' : 'none',
          }}
          paint={{
            'circle-color': theme.parcelClusterCircleFill,
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              20,
              100,
              30,
              750,
              40,
            ],
            'circle-stroke-width': 1,
            'circle-stroke-color': theme.parcelClusterCircleOutline,
          }}
        />
        <Layer
          id="parcel-cluster-text"
          source={clusterSource}
          type="symbol"
          filter={['has', 'point_count']}
          layout={{
            visibility: clustering && enabled ? 'visible' : 'none',
            'text-field': '{point_count_abbreviated}',
            'text-size': 12,
          }}
          paint={{
            'text-color': theme.parcelClusterText,
          }}
        />
        <Layer
          id="parcel-non-cluster-circle"
          source={clusterSource}
          type="circle"
          filter={['!', ['has', 'point_count']]}
          layout={{
            visibility: clustering && enabled ? 'visible' : 'none',
          }}
          paint={{
            'circle-color': theme.parcelClusterCircleFill,
            'circle-radius': 4,
            'circle-stroke-width': 1,
            'circle-stroke-color': theme.parcelClusterCircleOutline,
          }}
        />
        <Layer
          id="parcel-lines"
          source={linesSource}
          type="line"
          layout={{ visibility: enabled ? 'visible' : 'none' }}
          paint={{
            'line-color': theme.parcelOutline,
            'line-width': 1,
          }}
          minzoom={15}
        />
        <Layer
          id="parcel-fill"
          source={fillSource}
          type="fill"
          layout={{ visibility: enabled ? 'visible' : 'none' }}
          paint={{
            'fill-color': theme.parcelFill,
          }}
          minzoom={12}
        />
        <Layer
          id="parcel-points"
          source={pointsSource}
          type="circle"
          layout={{
            visibility: !clustering && enabled ? 'visible' : 'none',
          }}
          paint={{
            'circle-color': theme.parcelPointFill,
            'circle-radius': 3,
            'circle-stroke-width': 1,
            'circle-stroke-color': theme.parcelPointOutline,
          }}
        />
      </>
    )
  }
